import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAtom } from 'jotai';
import { userAtom } from '../../atoms';

export const BuyCardCheckingPage = () => {
    const navigate = useNavigate();
    const [user] = useAtom(userAtom);

    useEffect(() => {
        if (!user) {
            navigate('/dashboard');
            return;
        }

        if (user.is_debit_card_purchased) {
            navigate('/dashboard');
            return;
        }

        const hasPendingPurchase = user.activities.some(
            activity => activity.type === 'purchase_debit_card' && activity.status === 'checking'
        );

        if (!hasPendingPurchase) {
            navigate('/dashboard');
        }
    }, [user, navigate]);

    return (
        <div className="max-w-2xl mx-auto p-6">
            <h1 className="text-2xl font-bold mb-6">Payment Checking</h1>

            <div className="bg-blue-50 border border-blue-200 rounded-lg p-6 mb-6">
                <div className="flex items-center mb-4">
                    <span className="text-lg font-semibold">Checking Your Payment</span>
                </div>
                <p className="text-gray-700 mb-4">
                    We are currently verifying your payment for the debit card. This process typically takes 1-2 business days.
                </p>
            </div>

            <div className="space-y-4">
                <div className="bg-white border border-gray-200 rounded-lg p-6">
                    <h2 className="text-lg font-semibold mb-3">Next Steps</h2>
                    <ul className="list-disc list-inside space-y-2 text-gray-700">
                        <li>Our team will verify your payment</li>
                        <li>You will receive rewards when users buy the debit card from your link</li>
                    </ul>
                </div>

                <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-6">
                    <h2 className="text-lg font-semibold mb-3">Important Notes</h2>
                    <ul className="list-disc list-inside space-y-2 text-gray-700">
                        <li>Please do not make another payment while this transaction is being processed</li>
                        <li>You can check the status of your application on the dashboard</li>
                    </ul>
                </div>
            </div>
        </div>
    );
};